import { css } from 'styled-components'

export default css`
  .BaseModal-Content.popup {}

  &.DownloadTransactionsModal .BaseModal-Body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`
